<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      size="small"
      resizable
      border
    >
      <template v-slot:payCostAmount="{ row }">
        <div>
          <span>
            <el-link type="primary" @click="showAmount(row)">
              {{ row.payCostAmount }}
            </el-link>
          </span>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  components: {},
  props: {
    code: {
      type: String,
    },
  },
  data() {
    return {
      tableColumns: tableColumns(),
      tableData: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.code) return
      this.$api
        .finCarrierStatementChartersDetailListApi({
          carrierStatementCode: this.code,
        })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
    showAmount(row) {
      let data = row.payCostDetail
      let detail = []
      let msg = ''
      if (data === null || data === undefined || data === 'null' || data === ''){
        msg = '无费用明细'
      } else {
        detail = JSON.parse(data)
        detail.forEach((item) => {
          msg +=
            '<strong>' +
            item.feeName +
            '：<i>' +
            item.amount +
            '</i></strong><br/>'
        })
      }
      this.$alert(msg, '费用明细', {
        type: 'default',
        dangerouslyUseHTMLString: true,
      }).then(() => {})
    },
  },
}
</script>
<style lang="scss" scoped></style>
